import PropTypes from "prop-types";
import { helpdeskIcons } from "constants/icons";

function HelpDeskIcon({ width, height, categorySlug }) {
    const icon = helpdeskIcons[categorySlug] ?? helpdeskIcons.default;
    const isCovidIcon = categorySlug === "covid-19-corona";
    return (
        <svg width={width} height={height} viewBox="0 0 64 64">
            <defs>
                <path d={icon} id={`${categorySlug}-a`} />
            </defs>
            <g
                fill="#fff"
                fillRule="evenodd"
                transform={isCovidIcon && "translate(10 13.673825)"}
            >
                <mask id={`${categorySlug}-b`}>
                    <use xlinkHref={`#${categorySlug}-a`} />
                </mask>
                <use fillRule="nonzero" xlinkHref={`#${categorySlug}-a`} />
                <g mask={`url(#${categorySlug}-b)`}>
                    <path
                        d="M0 0h64v64H0z"
                        transform={isCovidIcon && "translate(-10 -19.673825)"}
                    />
                </g>
            </g>
        </svg>
    );
}

HelpDeskIcon.propTypes = {
    categorySlug: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number
};

HelpDeskIcon.defaultProps = {
    width: 48,
    height: 48
};

export default HelpDeskIcon;
